export function DataInicioAgendamento () {

    let dataInicio = new Date();

    if (dataInicio.getDay() === 5) {
      if (dataInicio.getHours() >= 15) {
        dataInicio.setDate(dataInicio.getDate() + 3);
    
        let diferencaHora = (17 - dataInicio.getHours()) * 60;
  
        if (diferencaHora <= 0) {
          dataInicio.setHours(10,29);
        } 
        else{
          let diferencaMinuto = 120 - (diferencaHora - (dataInicio.getMinutes()));
          dataInicio.setHours(8, 30);
          dataInicio.setMinutes(dataInicio.getMinutes() + diferencaMinuto);
        } 
      }
      else
      {
        dataInicio.setHours(dataInicio.getHours()+ 2);
      } 
      if (dataInicio.toLocaleTimeString() <= "06:30:00") {
        dataInicio.setHours(10,29);
      }
    } 
    else {
      if (dataInicio.getHours() >= 15) {
        dataInicio.setDate(dataInicio.getDate() + 1);

        let diferencaHora = (17 - dataInicio.getHours()) * 60;

        if (diferencaHora <= 0) {
          dataInicio.setHours(10,29);
        } 
        else{
          let diferencaMinuto = 120 - (diferencaHora - (dataInicio.getMinutes()));
          dataInicio.setHours(8, 30);
          dataInicio.setMinutes(dataInicio.getMinutes() + diferencaMinuto);
        } 
      }
      else
      {
        dataInicio.setHours(dataInicio.getHours() + 2);
      } 
      if (dataInicio.toLocaleTimeString() <= "06:30:00") {
        dataInicio.setHours(10,29);
      }
    }
    return dataInicio;
  };